






























// we must import our Modal plugin instance
// because it contains reference to our Eventbus
import Modal from "@/common/plugins/modal";
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "qModal",
})
export default class QModal extends Vue {
  public visible = false;
  public text = "";
  public confirmText = "削除";
  public confirmClass = "mb__add-color-red";
  public cancelText = "いいえ";
  // adding callback function variable
  public onConfirm = {};
  public onClose = {};
  public type = "";
  public title = "";
  public showCancelButton = true;
  public showQuestion = true;

  public titleMap = {
    // delete
    error: "削除確認",

    // cancel
    info: "変更内容を破棄します。",
  };

  public hide() {
    // this method is unchanged
    this.visible = false;
  }
  public confirm() {
    // we must check if this.onConfirm is function
    if (typeof this.onConfirm === "function") {
      // run passed function and then close the modal
      this.onConfirm();
      this.hide();
    } else {
      // we only close the modal
      this.hide();
    }
  }
  public close() {
    // we must check if this.onConfirm is function
    if (this.onClose && typeof this.onClose === "function") {
      // run passed function and then close the modal
      this.onClose();
      this.hide();
    } else {
      // we only close the modal
      this.hide();
    }
  }
  public show(parameters) {
    // making modal visible
    this.visible = true;
    // setting title and text
    this.text = parameters.text;
    this.confirmText = parameters.confirmText ? parameters.confirmText : "削除";
    this.cancelText = parameters.cancelText
      ? parameters.cancelText
      : "キャンセル";
    this.confirmClass = parameters.confirmClass
      ? parameters.confirmClass
      : "Green";

    // setting callback function
    this.onConfirm = parameters.onConfirm;
    this.onClose = parameters.onClose;
    this.type = parameters.type;
    this.showCancelButton =
      "showCancelButton" in parameters ? parameters.showCancelButton : true;
    this.showQuestion =
      "showQuestion" in parameters ? parameters.showQuestion : true;
    if (parameters.title) {
      this.title = parameters.title;
    } else {
      this.title = this.titleMap[this.type] || "";
    }
  }
  public beforeMount() {
    // here we need to listen for emited events
    // we declared those events inside our plugin
    Modal.EventBus.$on("show", (parameters) => {
      this.show(parameters);
    });
  }
}
